<template>
	<div v-if="isOpen" class="dimmed">
		<div class="img_box"><img src="@/assets/img/bi/bi.svg" alt="404" class="icon_404" /></div>
		<div class="content_box">
			<p class="content_title">대가의선택 앱으로<br />더 편리하게 이용할 수 있습니다.</p>
			<p class="content_sub-title">신규회원 이라면 최대 <strong>45%</strong> 할인 제공!</p>
		</div>
		<div class="button_box">
			<button class="c_button primary-fill radius-x-small font-bold" @click="onClick">앱 설치하기</button>
			<button class="web_button" @click="onClickWebButton">괜찮아요, 웹으로 볼게요</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import { useDeviceStore } from '@/stores/device';
import { useDisplayStore } from '@/stores/display';
import { isDeviceAOS, isDeviceIOS, openNativeWebAppStore } from '@/utils/native';

const displayStore = useDisplayStore();
const deviceStore = useDeviceStore();
const isOpen = ref(false);
const onClick = () => {
	openNativeWebAppStore();
};

const onClickWebButton = () => {
	document.body.classList.remove('hidden');
	sessionStorage.setItem('isWeb', 'false');
	isOpen.value = false;
};

onMounted(() => {
	if (
		!displayStore.isDesktop &&
		deviceStore.getDevice === 'MO' &&
		!isDeviceAOS &&
		!isDeviceIOS &&
		(!sessionStorage.getItem('isWeb') || sessionStorage.getItem('isWeb') === 'true')
	) {
		document.body.classList.add('hidden');
		sessionStorage.setItem('isWeb', 'true');
		isOpen.value = true;
	}
});
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.dimmed {
	z-index: 1000;
	position: fixed;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	background: rgba(0, 0, 0, 0.86);
	gap: 2.4rem;
	text-align: center;
	.img_box {
		padding: 2rem;
		background-color: var(--color-base-white);
		border-radius: 1.6rem;
		img {
			width: 6rem;
			height: 6rem;
		}
	}
	.content_box {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		.content_title {
			font-size: var(--font-s-large);
			font-weight: var(--font-w-bold);
			line-height: 25px;
		}
		.content_sub-title {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			line-height: 23px;
			strong {
				color: var(--color-primary);
			}
		}
	}
	.button_box {
		.c_button {
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			max-width: 18.75rem;
			width: 100%;
			height: 5.2rem;
			padding: 1.3rem 1.6rem;
		}
		.web_button {
			font-size: var(--font-s-small);
			font-weight: var(--font-w-semi-bold);
			line-height: normal;
			padding-top: 1.6rem;
			padding-bottom: 0.5rem;
			border-bottom: 1px solid var(--color-base-white);
		}
	}
}

.pageLoading_fade-enter-active,
.pageLoading_fade-leave-active {
	transition: opacity 0.15s ease-out;
}
.pageLoading_fade-enter-from,
.pageLoading_fade-leave-to {
	opacity: 0;
}
</style>
